module.exports = __webpack_public_path__ + "static/media/point_icon_04.a1f32060.svg";